export default __webpack_public_path__ + "cd9823129415486538bf81294ad308e1.jpg";